import type { PropsWithChildren } from 'react'

import AddedUpdatedBy from '../TripItems/Summary/Common/AddedUpdatedBy'

import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
}

export default function FooterWithCreateUpdateInfo({
  item,
  children,
}: PropsWithChildren<Props>) {
  const { createdAt, createdBy, userUpdatedAt, updatedBy, tripId } = item
  return (
    <ModalFooter>
      <Group
        direction="vertical"
        tabletDirection="horizontal"
        tabletVerticalAlign="center"
        tabletHorizontalAlign="space-between"
        gap={16}
        fullWidth
      >
        {/* THIS IS A HACK
          these fields will not exist on public trip items
          this is a temporary hack to ensure public trip can utilise the
          viewer trip context values for stable application behaviour
        */}
        {createdAt && createdBy && userUpdatedAt && updatedBy && (
          <AddedUpdatedBy
            tripId={tripId}
            createdAt={createdAt}
            createdBy={createdBy}
            updatedAt={userUpdatedAt}
            updatedBy={updatedBy}
            avatarSize="medium"
          />
        )}
        {children}
      </Group>
    </ModalFooter>
  )
}
